module.exports = __webpack_public_path__ + "img/background.6905fd7b.svg";